export const log = console.log;
export const debug = (...msg: any) => console.log(`[DEBUG]`, ...msg);
